import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { studyCompletionFormConfig } from '../study-completion-form.config';
import { ApiService } from "../../../api.service";
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../../../shared/common.service';

@Component({
  selector: 'app-study-completion-termination',
  templateUrl: './study-completion-termination.component.html',
  styleUrls: ['./study-completion-termination.component.scss']
})
export class StudyCompletionTerminationComponent implements OnInit {
  formConfig = studyCompletionFormConfig;

  studyId: string;
  studyName: string; // Add this property
  subjectId: string;
  folderName: string;
  formName: string;
  fieldLabel: string;
  todayDate: string;
  informedConsentDate: string;
  screeningMinDate: string;
  gender: string;
  fieldHistoryData: any[] = [];
  userDesignation: string;
  isOptionsModalOpen = false;
    // ✅ ADD THESE LINES
  studyCode: any;
  subjectName: any;
  siteLocation: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    const userData = this.commonService.getUserData();
    console.log('User Data from Cookie:', userData);
    this.userDesignation = userData.designation?.toLowerCase();

    const isLoggedIn = this.commonService.isLoggedIn();
    console.log('Is Logged In:', isLoggedIn);

    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;

    this.informedConsentDate = '';
    this.screeningMinDate = '';

    this.route.params.subscribe(params => {
      this.folderName = params['folderName'] ?? 'study-completion-termination';
      this.formName = params['formName'];
      console.log("Form Name:", this.formName);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.studyId = queryParams['studyId'];
      this.studyName = queryParams['name']; // Get study name from query params
      this.subjectId = queryParams['subjectId'];
    });

    console.log("Extracted Params:", {
      studyId: this.studyId,
      studyName: this.studyName, // Log study name
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });

    document.addEventListener('click', () => {
      this.isOptionsModalOpen = false;
    });

    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
            if (Array.isArray(response.data)) {
              this.mapFormData(response.data);
            } else {
              console.warn('Form data is not an array or is missing.');
            }

            this.mapStudyDetails(response.studyDetails);

            if (response.informedConsentDate !== undefined) {
              this.informedConsentDate = response.informedConsentDate;
              this.screeningMinDate = this.informedConsentDate;
              console.log("Informed Consent Date:", this.informedConsentDate);
            } else {
              console.warn('Informed consent date is missing in the response.');
            }

            this.gender = response.gender;
            console.log("gender:", this.gender);
          }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });

      const fieldName = this.fieldLabel || 'Unknown Field';
      this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
        .subscribe({
          next: (response) => {
            console.log('Fetched Field History for', fieldName, response);
            this.fieldHistoryData = response.data || [];
          },
          error: (error) => {
            console.error('Error fetching field history data:', error);
          }
        });
    }

    document.addEventListener('click', this.closeDropdownOnOutsideClick.bind(this));
  }

  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }

  mapFormData(data: any) {
    // Implement based on your form structure
  }

 mapStudyDetails(details: any): void {
  if (details) {
    this.studyCode = details.study_code;
    this.studyName = details.study_name;
    this.siteLocation = details.site_location;
    this.subjectName = this.subjectId;
  }
}


  closeDropdownOnOutsideClick(event: MouseEvent) {
    // Implement dropdown close behavior
  }
}



//   queryParams: any = {};
//   formName: string | null = null;
//   formData: any = {
//   studyComplete:'',
//   studyCompletionDate:'',
//   studyDiscontinuationDate:'',
//   };
//   tabs = [
//   { title: 'Query', type: 'query' },
//   { title: 'Field History', type: 'fieldHistory' }
// ];

//   fieldHistoryData: any[] = [];
//   selectedTab = 0;
//   isOptionsModalOpen = false;
//   isModalOpen = false;
//   queryText = '';
//   // closeQuery = false;
//   auditTrail: { user: string; role: string; timestamp: string; message: string }[] = [];
//   queries: { threadId: string; text: string; isClosed:boolean; auditTrail: { user: string; role: string; timestamp: string; message: string }[] }[] = [
//   {  threadId: this.generateThreadId(), text: '', isClosed: false , auditTrail: [] }
// ];
//   selectedOption = 'query'; // Default to Query section
//   discontinuationReasons: string[] = [
//     "Adverse Event",
//     "Lost to follow up",
//     "Study closed out",
//     "Investigator’s decision",
//     "Protocol Deviation",
//     "Abnormal Lab Values",
//     "Withdrew Consent",
//     "Unsatisfactory Therapeutic effect",
//     "Condition no longer requests study drug",
//     "Administrative Problems",
//     "Death"
//   ];
//   //edit thing
//   isDatePickerDisabled: boolean = false;
//   isStudyCompleteDisabled: boolean = false;
//   isDiscontinuationDisabled = false;
// isReasonModalOpen: boolean = false;
// editReason: string = '';

//   private questionMapping: { [key: string]: { question: string, field: string }[] } = {

//     'study-completion-termination-record': [
//         { question: '1. Did the Subject complete the study', field: 'studyComplete' },
//         { question: '2. Date of Study Completion:', field: 'studyCompletionDate' },
//     ],
//     'reason-for-discontinuation': [
//     { question: '1. Reason for Discontinuation:', field: 'discontinuationReason' },
//   ]
 
//   };
//   folderName: any;
//   studyId: any;
//   subjectId: any;
//   studyCode: any;
//   studyName: any;
//   subjectName: any;
//   siteLocation: any;
//   todayDate: string;
//   screeningMinDate: string;
//   informedConsentDate: string;
//   gender: any;
//   showReviewModal = false;
//   query: { auditTrail: any; };
//   fieldLabel: string | null = null; // Add this at the top

//   openQueries = [
//   'Adverse Event - Start Date',
//   'Concomitant - Date'
// ];
// answeredQueries = [
//   'Screening visit - Language of informed consent form'
// ];
// reviewQueries = [
//   'Medical History - Diagnosis Date'
// ];
// signatureQueries = [
//   'Study Completion Form - PI Signature',
//   'Discontinuation Form - Coordinator Signature'
// ];


// activeDropdown: 'open' | 'answered' | 'review' | 'signature' | null = null;


// toggleDropdown(type: 'open' | 'answered' | 'review'| 'signature') {
//   this.activeDropdown = this.activeDropdown === type ? null : type;
// }

// //review code
// isReviewCheckboxDisabled: boolean = true;
// userDesignation: string = '';

//   constructor(
//     private route: ActivatedRoute,
//     private router: Router,
//     private apiService: ApiService,
//     private commonService: CommonService
//   ) {}
//   ngOnInit(): void {

//      // Example: Console log user data from cookies
//   const userData = this.commonService.getUserData();
//   console.log('User Data from Cookie:', userData);
//   this.userDesignation = userData.designation?.toLowerCase(); // Save and normalize
  
//   const isLoggedIn = this.commonService.isLoggedIn();
//   console.log('Is Logged In:', isLoggedIn);

//     const today = new Date();
//     const day = String(today.getDate()).padStart(2, '0');
//     const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
//     const year = today.getFullYear();
//     this.todayDate = `${year}-${month}-${day}`;
  
//     this.informedConsentDate = ''; // Start with an empty value
//     this.screeningMinDate = ''; // Same for screeningMinDate

//     this.route.params.subscribe(params => {
//       this.folderName = params['folderName'] ?? 'study-completion-termination';;
//       this.formName = params['formName'];
//       console.log("Form Name:", this.formName);
//     });
  
//     this.route.queryParams.subscribe(queryParams => {
//       this.studyId = queryParams['studyId'];
//       this.subjectId = queryParams['subjectId'];
//     });
//     console.log("Extracted Params:", {
//       studyId: this.studyId,
//       subjectId: this.subjectId,
//       folderName: this.folderName,
//       formName: this.formName
//     });
//     document.addEventListener('click', () => {
//       this.isOptionsModalOpen = false;
//     });
    

//     if (this.studyId && this.subjectId && this.folderName && this.formName) {
//       this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
//         next: (response) => {
//           console.log('Fetched Form Data:', response);
//           if (response.success) {
//            // Ensure response.data is an array before mapping
//            if (Array.isArray(response.data)) {
//             this.mapFormData(response.data);
//           } else {
//             console.warn('Form data is not an array or is missing.');
//           }
//           this.mapStudyDetails(response.studyDetails);

//           // Dynamically update informedConsentDate from the response
//           if (response.informedConsentDate !== undefined) {
//             this.informedConsentDate = response.informedConsentDate;
//             this.screeningMinDate = this.informedConsentDate;  // Set min date
//             console.log("Informed Consent Date:", this.informedConsentDate);
//           } else {
//             console.warn('Informed consent date is missing in the response.');
//           }
//            // Store the gender from the response
//            this.gender = response.gender;
//            console.log("gender:",this.gender);
//         }
//         },
//         error: (error) => {
//           console.error('Error fetching form data:', error);
//         }
//       });

//       // const fieldName = '2. Date of Study Completion:';
//       const fieldName = this.fieldLabel || 'Unknown Field';
//   this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
//     .subscribe({
//       next: (response) => {
//         console.log('Fetched Field History for', fieldName, response);
//         this.fieldHistoryData = response.data || [];
//       },
//       error: (error) => {
//         console.error('Error fetching field history data:', error);
//       }
//     });


//     }
//      document.addEventListener('click', this.closeDropdownOnOutsideClick.bind(this));
// }

// closeDropdownOnOutsideClick(event: MouseEvent) {
//   const target = event.target as HTMLElement;

//   // Check if the click is on the dropdown box or trigger
//   const clickedInsideDropdown = target.closest('.dropdown-wrapper');
//   if (!clickedInsideDropdown) {
//     this.activeDropdown = null;
//   }

//   }
//   addTab(label: string = 'Date of Study Completion') {
//   const fieldName = label.trim(); // You can enhance this mapping if needed

//   this.apiService.getInsertHistoryData(this.studyId, this.subjectId, this.folderName, this.formName, fieldName)
//     .subscribe({
//       next: (response) => {
//         console.log('Fetched Field History for', fieldName, response);
//         this.fieldHistoryData = response.data || [];
        
//         // Add tab only after fetching data
//         this.tabs.push({ title: 'Field History', type: 'fieldHistory' });
//         this.selectedTab = this.tabs.length - 1;
//       },
//       error: (error) => {
//         console.error('Error fetching field history data:', error);
//       }
//     });
// }


// generateThreadId(): string {
//   return 'thread-' + Math.random().toString(36).substr(2, 9);
// }







//   selectTab(index: number) {
//     this.selectedTab = index;
//     const selected = this.tabs[index];
//   if (selected.type === 'query') {
//     // const fieldName = '2. Date of Study Completion:'; // Or dynamically set based on tab
//     const fieldName = this.fieldLabel || 'Unknown Field';
//     console.log('Fetching Query History for Field:', fieldName); // <-- Add this
//     this.apiService.getQueryHistoryData(
//       this.studyId,
//       this.subjectId,
//       this.folderName,
//       this.formName,
//       fieldName
//     ).subscribe({
//       next: (response) => {
//         console.log('Fetched Query History Data:', response);
//         // You can decide how to display this – either integrate it into the auditTrail or a dedicated UI block
//         // Example: populate audit trails per query
//          if (response.data && Array.isArray(response.data)) {
//           const auditTrail = response.data.map((item: any) => {
//             const subData = item.sub_data ? JSON.parse(item.sub_data) : {};
//             return {
//               user: item.updated_by || 'Unknown',
              
//               timestamp: subData.timestamp || item.updated_at,
//               message: item.value || ''
//             };
//           });
       
//         }
//       },
//       error: (error) => {
//         console.error('Error fetching query history data:', error);
//       }
//     });
//   }
//   if (selected.type === 'fieldHistory') {
//     const fieldName = this.fieldLabel || 'Unknown Field';
//     console.log('Fetching Field History for:', fieldName);
//     this.apiService.getInsertHistoryData(
//       this.studyId,
//       this.subjectId,
//       this.folderName,
//       this.formName,
//       fieldName
//     ).subscribe({
//       next: (response) => {
//         console.log('Fetched Field History Data:', response);
//         this.fieldHistoryData = response.data || [];
//       },
//       error: (error) => {
//         console.error('Error fetching field history data:', error);
//       }
//     });
//   }

// }
  
//   closeTab(index: number, event: MouseEvent) {
//     event.stopPropagation();
//     this.tabs.splice(index, 1);
//     if (this.selectedTab >= this.tabs.length) {
//       this.selectedTab = this.tabs.length - 1;
//     }
//   }
// openReviewModal() {
//   this.showReviewModal = true;

//   const fieldName = this.fieldLabel || 'Unknown Field';
//   console.log('Opening Review Modal - Fetching Field History for:', fieldName);

//   this.apiService.getInsertHistoryData(
//     this.studyId,
//     this.subjectId,
//     this.folderName,
//     this.formName,
//     fieldName
//   ).subscribe({
//     next: (response) => {
//       console.log('Fetched Field History Data (from review modal):', response);
//       this.fieldHistoryData = response.data || [];

//       // Initialize default review flags
//       let latestReview = {
//         dataMonitor: false,
//         monitor: false,
//         pi: false
//       };

//       // Sort descending by updated_at to get the latest ones first
//       const sortedData = [...this.fieldHistoryData].sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());

//       const flagsFound = {
//         dataMonitor: false,
//         monitor: false,
//         pi: false
//       };

//       for (const entry of sortedData) {
//         if (!entry.review_status) continue;

//         try {
//           const parsed = JSON.parse(entry.review_status);

//           // For each reviewer type, only update if not already found (i.e., get the latest one)
//           if (!flagsFound.dataMonitor && parsed.hasOwnProperty('dataMonitor')) {
//             latestReview.dataMonitor = parsed.dataMonitor;
//             flagsFound.dataMonitor = true;
//           }

//           if (!flagsFound.monitor && parsed.hasOwnProperty('monitor')) {
//             latestReview.monitor = parsed.monitor;
//             flagsFound.monitor = true;
//           }

//           if (!flagsFound.pi && parsed.hasOwnProperty('pi')) {
//             latestReview.pi = parsed.pi;
//             flagsFound.pi = true;
//           }

//           // If all found, stop early
//           if (flagsFound.dataMonitor && flagsFound.monitor && flagsFound.pi) {
//             break;
//           }

//         } catch (err) {
//           console.error("Error parsing review_status JSON:", err);
//         }
//       }

//       this.reviewOptions = latestReview;
//       console.log("✅ Final reviewOptions applied:", this.reviewOptions);
//     },

//     error: (error) => {
//       console.error('Error fetching field history data from review modal:', error);
//     }
//   });
// }



// closeReviewModal() {
//   this.showReviewModal = false;
// }
// openOptionsModal(event: MouseEvent, target: EventTarget | null) {
//   event.stopPropagation();
//   this.isOptionsModalOpen = true;

//   // Traverse to the closest parent with `data-label`
//   const icon = target as HTMLElement;
//   const fieldGroup = icon.closest('.form-group');

//   if (fieldGroup) {
//     this.fieldLabel = fieldGroup.getAttribute('data-label');
//     console.log('Dynamically captured label:', this.fieldLabel);
//   }
// }



// openModal() {
//   this.isModalOpen = true;
//   this.selectedTab = 0; // Default to 'Query'

//   // const fieldName = '2. Date of Study Completion:'; // Or dynamically get it
//   const fieldName = this.fieldLabel || 'Unknown Field';
//  console.log("Opening modal - Fetching field name:", fieldName); // <-- Add this

//   this.apiService.getQueryHistoryData(
//     this.studyId,
//     this.subjectId,
//     this.folderName,
//     this.formName,
//     fieldName
//   ).subscribe({
//     next: (response) => {
//       console.log('Fetched Query History Data:', response);

//       if (response.success && Array.isArray(response.data)) {
//         this.queries = response.data.map((entry: any) => {
//           const auditTrail = entry.auditTrail?.map((a: any) => ({
//             user: a.user,
//             timestamp: a.timestamp,
//             message: typeof a.message === 'string' ? a.message : String(a.message)
//           })) || [];

//           const isClosed = auditTrail.some(item => 
//   typeof item.message === 'string' && item.message.toLowerCase().includes('query closed')
// );

// const query = {
//   threadId: entry.threadId || 'no-thread',
//   text: this.getInitialQueryText(auditTrail) || '',
//   isClosed: isClosed,
//   auditTrail: auditTrail
// };

         

//           return query;
//         });
//       } else {
//         // Fallback for empty or invalid data
//         this.queries = Array(3).fill(null).map(() => ({
//           threadId: this.generateThreadId(),
//           text: '',
//           isClosed: false,
//           auditTrail: []
//         }));
//       }
//     },
//     error: (error) => {
//       console.error('Error fetching query history:', error);
//       this.queries = [{
//         threadId: this.generateThreadId(),
//         text: '',
//         isClosed: false,
//         auditTrail: []
//       }];
//     }
//   });
// }

// getInitialQueryText(auditTrail: any[]): string {
//   if (!Array.isArray(auditTrail)) return '';

//   // Look for latest message or first valid message in each query's auditTrail
//   const validEntry = auditTrail
//     .filter(a => typeof a.message === 'string' && a.message.trim() && a.message.toLowerCase() !== 'query closed')
//     .pop(); // or use [0] for first message

//   return validEntry ? validEntry.message : '';
// }

// closeModal() {
//   this.isModalOpen = false;
//   document.body.classList.remove('modal-open');
// }


// addQuery(index: number) {
//   this.queries.splice(index + 1, 0, {
//     threadId: this.generateThreadId(),
//     text: '',
//     isClosed: false,
//     auditTrail: []
//   });
// }
// submitQuery(index: number) {
//   const userData = this.commonService.getUserData(); // Extract from cookies
//   console.log('userData:', userData); // Check the structure
//   const fullName = `${userData.first_name} ${userData.last_name}`;
//   const designation = userData.designation || 'N/A'; // Fallback if not available

//   const timestamp = new Date().toISOString(); // ISO format for backend

//   const query = this.queries[index];

//   if (!query.text || !query.text.trim()) {
//     console.warn('No text entered for this query. Ignoring submit.');
//     return;
//   }

//   // Ensure threadId
//   if (!query.threadId) {
//     query.threadId = this.generateThreadId();
//   }

//   const payloadItem = {
//     studyId: this.studyId,
//     subjectId: this.subjectId,
//     folderName: this.folderName,
//     formName: this.formName,
//     // fieldName: '2. Date of Study Completion:',
//     fieldName :this.fieldLabel || 'Unknown Field',
//     threadId: query.threadId,
//     queryText: query.text.trim(),
//     user: fullName,
//     designation: designation,
//     timestamp: timestamp
//   };
//    console.log('Submitting Query Payload:', payloadItem); // <-- Important log

//   this.apiService.submitQueryData([payloadItem]).subscribe({
//     next: (response) => {
//       console.log('Query submitted:', response);

//       query.auditTrail = query.auditTrail || [];
//       query.auditTrail.push({
//         user: fullName,
//         role: designation,
//         timestamp: new Date().toLocaleString(),
//         message: payloadItem.queryText
//       });
//  query.text = ''; // Clear only this one
//     },
//     error: (error) => {
//       console.error('Error submitting query:', error);
//     }

     
//     });
//   }

// reviewOptions = {
//   dataMonitor: false,
//   monitor: false,
//   pi: false
// };
 
// confirmCloseQuery(index: number): void {
//   const confirmed = window.confirm('Are you sure you want to close this query?');
//   if (confirmed) {
//     this.closeQuery(index);
//   }
// }
// closeQuery(index: number): void {
//   const userData = this.commonService.getUserData();
//   const fullName = `${userData.first_name} ${userData.last_name}`;
//   const designation = userData.designation || 'N/A';
//   const timestamp = new Date().toISOString(); // For backend
//   const localTime = new Date().toLocaleString(); // For UI

//   const query = this.queries[index];
//   if (!query.threadId) {
//     query.threadId = this.generateThreadId();
//   }

//   const closeMessage = 'Query closed';

//   const payloadItem = {
//     studyId: this.studyId,
//     subjectId: this.subjectId,
//     folderName: this.folderName,
//     formName: this.formName,
//     // fieldName: '2. Date of Study Completion:',
//     fieldName : this.fieldLabel || 'Unknown Field',
//     threadId: query.threadId,
//     queryText: closeMessage,
//     user: fullName,
//     designation: designation,
//     timestamp: timestamp,
//     isClosed: true  // Optional, in case your backend expects a flag
//   };

//   this.apiService.submitQueryData([payloadItem]).subscribe({
//     next: (response) => {
//       console.log('Query closed:', response);
      

//       query.auditTrail = query.auditTrail || [];
//       query.auditTrail.push({
//         user: fullName,
//         role: designation,
//         timestamp: localTime,
//         message: closeMessage
//       });
//       query.isClosed = true;
//       alert('Query closed successfully');
//     },
//     error: (error) => {
//       console.error('Error closing query:', error);
//     }
//   });
// }
// confirmSubmitQuery(index: number): void {
//   const confirmSubmit = confirm('Are you sure you want to submit the data?');
//   if (confirmSubmit) {
//     this.submitQuery(index);
//     alert('Data submitted successfully');
//   }
// }


//   // Function to map study details
// mapStudyDetails(studyDetails: any): void {
//   if (studyDetails) {
//     this.studyCode = studyDetails.study_code;
//     this.studyName = studyDetails.study_name;
//     this.siteLocation = studyDetails.site_location;
//     this.subjectName = this.subjectId; // Mapping subjectId to subjectName
//   }
// }
// hasStudyCompleteData = false;
// hasStudyCompletionDateData = false;
// hasDiscontinuationReasonData = false;

// mapFormData(data: any[]): void {
//   this.hasStudyCompleteData = false;
//   this.hasStudyCompletionDateData = false;
//   this.hasDiscontinuationReasonData = false;

//   data.forEach(item => {
//     const fieldName = item.field_name?.trim(); // Ensure no leading/trailing spaces
//     const fieldValue = item.value;

//     // Map checkbox values
//     if (fieldName === 'reviewedByDataMonitor') this.reviewOptions.dataMonitor = fieldValue === 'true';
//     if (fieldName === 'reviewedByMonitor') this.reviewOptions.monitor = fieldValue === 'true';
//     if (fieldName === 'reviewedByPI') this.reviewOptions.pi = fieldValue === 'true';

//     switch (fieldName) {
//       case '1. Did the Subject complete the study':
//         this.formData.studyComplete = fieldValue;
//         this.hasStudyCompleteData = !!fieldValue;
//         this.isStudyCompleteDisabled = !!fieldValue;
//         if (fieldValue === 'no' && item.sub_data) {
//           const subData = JSON.parse(item.sub_data); // Parse sub_data JSON
//           this.formData.studyComments = subData.studyComments || '';
//           this.formData.studyDiscontinuationDate = subData.studyDiscontinuationDate || null;
//         }
//         break;

//       case '2. Date of Study Completion:':
//         this.formData.studyCompletionDate = fieldValue;
//         this.hasStudyCompletionDateData = !!fieldValue;
//         this.isDatePickerDisabled = !!fieldValue;
//         break;

//       case '1. Reason for Discontinuation:':
//         this.formData.discontinuationReason = fieldValue;
//         this.hasDiscontinuationReasonData = !!fieldValue;
//         this.isDiscontinuationDisabled = !!fieldValue;
//         if (item.sub_data) {
//           try {
//             const subData = JSON.parse(item.sub_data);
//             if (Array.isArray(subData)) {
//               this.formData.discontinuationComments = subData[0]?.discontinuationComments || item.sub_data;
//               this.formData.dateOfDeath = subData[0]?.dateOfDeath || null;
//             } else if (typeof subData === 'object') {
//               this.formData.discontinuationComments = subData.discontinuationComments || item.sub_data;
//               this.formData.dateOfDeath = subData.dateOfDeath || null;
//             } else {
//               this.formData.discontinuationComments = item.sub_data;
//             }
//           } catch (error) {
//             this.formData.discontinuationComments = item.sub_data;
//           }
//         }
//         break;
//     }
//   });
// }
// editStudy() {
//   // Open edit reason modal only if field already has a value
//   if (this.fieldLabel === '2. Date of Study Completion:' && this.formData.studyCompletionDate) {
//     this.isReasonModalOpen = true;
//   }else if (this.fieldLabel === '1. Did the Subject complete the study' && this.formData.studyComplete) {
//     this.isReasonModalOpen = true;
//   } else if (this.fieldLabel === '1. Reason for Discontinuation:' && this.formData.discontinuationReason) {
//     this.isReasonModalOpen = true;
//   }else {
//     // First time - no need to ask
//     if (this.fieldLabel === '2. Date of Study Completion:') {
//       this.isDatePickerDisabled = false;
//     } 
//     else if (this.fieldLabel === '1. Reason for Discontinuation:') {
//       this.isDiscontinuationDisabled = false;
//     }
//     }
// }
// confirmEditReason() {
//   if (!this.editReason.trim()) {
//     alert('Please enter a reason before proceeding.');
//     return;
//   }

//   if (this.fieldLabel === '2. Date of Study Completion:') {
//     this.isDatePickerDisabled = false;
//   } else if (this.fieldLabel === '1. Did the Subject complete the study') {
//     this.isStudyCompleteDisabled = false;
//   } else if (this.fieldLabel === '1. Reason for Discontinuation:') {
//     this.isDiscontinuationDisabled = false;
//   }

//   this.isReasonModalOpen = false;
// }
// cancelEditReason() {
//   this.isReasonModalOpen = false;
//   this.editReason = '';
// }


  
//   submitForm() {
//     if (this.isModalOpen) {
//       return; // Skip if modal is open (indicating query submission)
//     }
//     // if(this.showReviewModal){
//     //   return;
//     // }
//     if(this.isReasonModalOpen){
//       return;
//     }

//     const userData = this.commonService.getUserData(); // Extract from cookies
//   console.log('userData:', userData); // Check the structure
//   const fullName = `${userData.first_name} ${userData.last_name}`;

//     let questionAnswers: { [key: string]: any } = {};
  
//     if (this.formName && this.questionMapping[this.formName]) {
//       this.questionMapping[this.formName].forEach(mapping => {
//         let fieldKey = mapping.question; // Use question text as key
      
//         if (this.formName === 'study-completion-termination-record') {
//           if (mapping.field === 'studyComplete' && this.formData.studyComplete === 'no') {
//             questionAnswers[fieldKey] = {
//               answer: "no",
//               value: {
//                 studyComments: this.formData.studyComments,
//                 studyDiscontinuationDate: this.formData.studyDiscontinuationDate
//               },
//               editReason: this.editReason || '', // Include edit reason if provided
//                reviewStatus: { ...this.reviewOptions }
//             };
//           }else if (mapping.field === 'studyCompletionDate') {
//     questionAnswers[fieldKey] = {
//       answer: this.formData[mapping.field],
//       editReason: this.editReason || '', // Include edit reason if provided
//        reviewStatus: { ...this.reviewOptions }
//     };
//    } else {
//             questionAnswers[fieldKey] = this.formData[mapping.field];
//           }
//         }
//         else if (this.formName === 'reason-for-discontinuation') {
//           // For Reason for Discontinuation, include comments with the answer
//           if (mapping.field === 'discontinuationReason') {
//             if (this.formData.discontinuationReason === 'Death') {
//               // Store comments and date as an array of objects
//               questionAnswers[fieldKey] = {
//                 answer: this.formData[mapping.field], // Store the selected reason
//                 value: [
//                   { discontinuationComments: this.formData.discontinuationComments, dateOfDeath: this.formData.dateOfDeath }
//                 ],
//                  editReason: this.editReason || '', // Include edit reason if provided
//                   reviewStatus: { ...this.reviewOptions }
//               };
//             } else {
//               questionAnswers[fieldKey] = {
//                 answer: this.formData[mapping.field], // Store the selected reason
//                 value: this.formData.discontinuationComments, // Store the comments associated with the reason
//                  editReason: this.editReason || '', // Include edit reason if provided
//                   reviewStatus: { ...this.reviewOptions } 
//               };
//             }
//           } else {
//             // For other fields like Date of Death
//            questionAnswers[fieldKey] = {
//       answer: this.formData[mapping.field],
//       editReason: this.editReason || '', // Include edit reason if provided,
//        reviewStatus: { ...this.reviewOptions }
//     };
//           }
//         }
//       });
//     }
  
  


//             const submittedData = {
//               folderName: "study-completion-termination",
//               formName: this.formName,
//               studyId: this.studyId,
//               subjectId: this.subjectId,
//                user: fullName, 
//               ...questionAnswers
//           };
        
//             console.log("Form Submitted:", submittedData);
        
//             this.apiService.insertFormData(submittedData).subscribe({
//                 next: (response) => {
//                     console.log("Response from API:", response);
//                     alert("Form Submitted Successfully!");

//                     // ✅ Disable calendar and clear edit reason after successful submission
//       this.isDatePickerDisabled = true;
//       this.isStudyCompleteDisabled = true;
//       this.isDiscontinuationDisabled = true;  // ← lock it down
//       this.editReason = '';
    
//                 },
//                 error: (error) => {
//                     console.error("Error submitting form:", error);
//                     alert("Error submitting form. Please try again.");
//                 }
//             });
//         }
    

//   insertFormData(submittedData: { folderName: string | null; formName: string | null; studyId: string | null; subjectId: string | null; }) {
//     throw new Error('Method not implemented.');
//   }
//   goBack() {
//     this.router.navigate(['/study-details', this.studyId]);
//   }
//   createField() {
//     alert("Create Field Clicked!");
//   }
// }
